// @flow

import styled, { useTheme } from 'styled-components';
import type { Node } from 'react';
import React from 'react';
import PreviewIcon from '../icons/preview';
import Link from './link';
import { buildVersionSelector, colors } from '../constants';
import PrimaryPalette from '../../birch/colors';

type Props = $ReadOnly<{
  children: Node,
  href: string,
}>;

const azaleaVersion = {
  linkColor: colors.mediumBlue,
};

const birchVersion = {
  linkColor: PrimaryPalette.linkGreen,
};

const versionSelector = buildVersionSelector(azaleaVersion, birchVersion);

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const StyledLink = styled<{}>(Link)`
  svg {
    margin-left: 4px;
  }
`;

function ExternalLink(props: Props) {
  let { children, href, ...rest } = props;
  const theme = useTheme();
  return (
    <StyledLink href={href} {...rest} target="_blank" rel="noopener norefferer">
      {children}
      <PreviewIcon color={versionSelector(theme?.name).linkColor} size={12} />
    </StyledLink>
  );
}

export default ExternalLink;
